import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import { GetSmsProviderSendersResponse } from '../../types'

function useQueryGetSMSProviderSenders(
	providerId: string,
	props?: UseBaseQueryOptions<GetSmsProviderSendersResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetSMSProviderSenders, providerId],
		queryFn: () => MessagingService.getSMSProviderSenders(providerId),
		enabled: !!providerId,
		...props,
	})
}

export default useQueryGetSMSProviderSenders
